import React from "react";
import { withLocalize, Translate } from "react-localize-redux";
import FinanceChart from "./basicInfo/financeChart";
import ExportImport from "./basicInfo/exportImport";
import Section from "../common/section";
import ExcelExportButton from "../common/excelExportButton";
import classnames from "classnames";
import UnderlinedTitle from "../common/underlinedTitle";
import "./basicInfo.scss";
import OldStyleTableWithHistory from '../common/oldStyleTableWithHistory';
import { reportActions } from '../../store/reportStore';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class BasicInfo extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? "" : this.renderWithData(this.props.data));
    }

    renderWithData(data) {
        const hdPortion = this.getFullHdPortion(data)
        return (
            <div>
                <div className='columns is-multiline is-centered'>
                    {data.capital.length > 0 && this.renderCapital(data.capital, hdPortion)}
                    {data.shares.length > 0 && this.renderSharesWithHistory(data.shares, hdPortion)}
                    {data.turnover.length > 0 && this.renderTurnOver(data.turnover, hdPortion, data.subjectCountry)}
                    {data.employees.length > 0 && this.renderEmployees(data.employees, hdPortion, data.subjectCountry)}
                </div>

                {data.fin.length > 0 && <div className="columns is-multiline">
                    <div className="column is-4-fullhd is-12">
                        <div className="box scrn-h-100" >
                            <FinanceChart data={data.fin} whichProp="sales" widthPct="33%" header={this.props.translate("Report.BasicInfo.Revenues", { currency: (data.subjectCountry === "CZ") ? "CZK" : "EUR" })} color={`url('${window.location.pathname}#colorSales')`} />
                        </div>
                    </div>
                    <div className="column is-4-fullhd is-12">
                        <div className="box scrn-h-100" >
                            <FinanceChart data={data.fin} whichProp="profit" widthPct="33%" header={this.props.translate("Report.BasicInfo.ProfitLoss", { currency: (data.subjectCountry === "CZ") ? "CZK" : "EUR" })} color={`url('${window.location.pathname}#colorProfit')`} />
                        </div>
                    </div>
                    <div className="column is-4-fullhd is-12">
                        <div className="box scrn-h-100" >
                            <FinanceChart data={data.fin} whichProp="assets" widthPct="33%" header={this.props.translate("Report.BasicInfo.Assets", { currency: (data.subjectCountry === "CZ") ? "CZK" : "EUR" })} color={`url('${window.location.pathname}#colorAsset')`} />
                        </div>
                    </div>
                </div>
                }
                {(data.expImp.total !== 0 || data.expImp.year !== 0 || data.expImp.export.length > 0 || data.expImp.import.length > 0) &&
                    <Section level={2} name={this.props.translate("Report.BasicInfo.ExportImportHeader")}>
                        <ExportImport data={data.expImp} currency={data.currency} />
                    </Section>
                }
                <ExcelExportButton link="basic-fin-info" entityId={this.props.id} report={this.props.reportType} />
            </div>
        )
    }

    numberOfTableBoxes = data => (data.capital.length > 0) + (data.shares.length > 0) + (data.turnover.length > 0) + (data.employees.length > 0);

    getFullHdPortion = data => `is-${((data) => {
        switch (this.numberOfTableBoxes(data)) {
            case 1:
                return 4;
            case 2:
                return 6;
            case 3:
                return 4;
            case 4:
                return 6;
            default:
                return 6;
        }
    })(data)}-fullhd`;

    renderCapital = (capital, hdPortion) => {
        let data = capital.filter(c => c.end != null).filter((c, idx) => idx < 2);
        return (
            <div className={classnames('column has-text-centered is-12', hdPortion)} style={{ border: '1px' }}>
                <div className="box scrn-h-100">
                    <UnderlinedTitle header={<Translate id="Report.BasicInfo.InitialAsset" />} />
                    <br />
                    {capital.length > 0 && capital.find(c => c.end === null) !== undefined &&
                        <div className={classnames({ 'capital-center-wrapper': capital.filter(c => c.end != null).length <= 0 })}>
                            <div className={classnames({ 'capital-center': capital.filter(c => c.end != null).length <= 0 })} style={{ fontSize: "1.2em", marginTop: "1em", marginBottom: "2em", fontWeight: "600" }}>
                                {capital.find(c => c.end === null).amount} {capital.find(c => c.end === null).currency}
                            </div>
                        </div>}
                    {data && data.length > 0 && <OldStyleTableWithHistory stripped tableColumns={3} fixed={false}
                        head={() => this.renderHead()}
                        resolveExpanded={this.props.resolveExpanded}
                        actualData={data}
                        actualRow={(r, i) => this.renderRow(r, i)}
                        historyData={capital.filter(c => c.end != null).filter((c, idx) => idx > 1)}
                        historyRow={(r, i) => this.renderRow(r, i)}
                        showAsMore={true}
                    />}
                </div>
            </div>
        );
    }

    renderHead = () =>
        <thead>
            <tr>
                <th className="w-50"><Translate id="Report.BasicInfo.InitialAsset" /></th>
                <th className="w-25"><Translate id="Report.Common.From" /></th>
                <th className="w-25"><Translate id="Report.Common.To" /></th>
            </tr>
        </thead>

    renderRow = (data, i) =>
        <tr key={i} className="colorize">
            <td className="w-50 bold">{data.amount} {data.currency}</td>
            <td className="w-25">{data.start}</td>
            <td className="w-25">{data.end}</td>
        </tr>

    renderSharesWithHistory = (shares, hdPortion) => {
        return (shares && shares.length > 0 &&
            <div className={classnames('column is-12', hdPortion)}>
                <div className="box scrn-h-100">
                    <UnderlinedTitle header={<Translate id='Report.BasicInfo.Shares' />} />
                    <br />
                    <OldStyleTableWithHistory stripped tableColumns={3} fixed={false}
                        head={() => this.renderSharesHead()}
                        resolveExpanded={this.props.resolveExpanded}
                        actualData={shares.filter(c => !c.isInactive)}
                        actualRow={(r, i) => this.renderSharesRow(r, i)}
                        historyData={shares.filter(c => c.isInactive)}
                        historyRow={(r, i) => this.renderSharesRow(r, i)}
                        showAsMore={true}
                        classnames={'table table-report-section-3'}
                    />
                </div>
            </div>
        )
    }

    renderSharesRow = (data, index) => {
        return <tr key={index} className="colorize">
            <td className="w-25 bold">{data.form}</td>
            <td className="w-20">{data.value}</td>
            <td className="w-5">{data.volume}</td>
            <td className="w-20">{data.type}</td>
            <td className="w-15">{data.from}</td>
            <td className="w-15">{data.to}</td>
        </tr>
    }

    renderSharesHead = () => {
        return <thead>
            <tr>
                <th className="w-25"><Translate id="Report.BasicInfo.Shares" /></th>
                <th className="w-20"><Translate id="Report.BasicInfo.Value" /></th>
                <th className="w-5"><Translate id="Report.BasicInfo.VolumeIssuedShort" /></th>
                <th className="w-20"><Translate id="Report.BasicInfo.ShareType" /></th>
                <th className="w-15"><Translate id="Report.Common.From" /></th>
                <th className="w-15"><Translate id="Report.Common.To" /></th>
            </tr>
        </thead>
    }

    renderTurnOver = (turnover, hdPortion, country) => {
        return (
            <div className={classnames('column is-12', hdPortion)}>
                <div className="box scrn-h-100">
                    <UnderlinedTitle header={<Translate id='Report.BasicInfo.Turnover' />} />
                    <br />
                    <table className="table table-report-section-3">
                        <thead>
                            <tr>
                                <th className="w-30">{(country === "CZ") ? this.props.translate("Report.BasicInfo.Year.Cz") : this.props.translate("Report.BasicInfo.Year")}</th>
                                <th className="w-70"><Translate id="Report.BasicInfo.TurnoverCategory" /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {turnover.map((t, i) => {
                                return <tr key={i} className="colorize">
                                    <td className="w-30 bold">{t.year}</td>
                                    <td className="w-70">{t.desc}</td>
                                </tr>

                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    renderEmployees = (employees, hdPortion, country) => {
        return (
            <div className={classnames('column is-12', hdPortion)}>
                <div className="box scrn-h-100">
                    <UnderlinedTitle header={<Translate id='Report.BasicInfo.EmployeeCountRange' />} />
                    <br />
                    <table className="table table-report-section-3">
                        <thead>
                            <tr>
                                <th className="w-30">{(country === "CZ") ? this.props.translate("Report.BasicInfo.Year.Cz") : this.props.translate("Report.BasicInfo.Year")}</th>
                                <th className="w-40"><Translate id="Report.BasicInfo.EmployeeCountRange" /></th>
                                <th className="w-30"><Translate id="Report.BasicInfo.EmployeeCount" /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {employees.map((e, i) => {
                                return <tr key={i} className="colorize">
                                    <td className="w-30 bold">{e.year}</td>
                                    <td className="w-40">
                                        {e.isEmpty && e.desc}
                                        {!e.isEmpty && e.min === e.max && e.min}
                                        {!e.isEmpty && e.min !== e.max && (e.max < 1000000000 ? <>{e.min} - {e.max}</> : <>{e.min} <Translate id="Report.SimpleAccounting.AndMore" /></>)}
                                    </td>
                                    <td className="w-30">{e.count}</td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(BasicInfo));
